import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  AvailabilityAndViewButton,
  ButtonViewAvailability,
  ButtonViewDetails,
  CoachTitle,
  ContentDescriptLang,
  DateDescription,
  GeneralListMyCoach,
  ImageCoach,
  useStyles,
} from "./ListOfMyCoaches.styled";
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";
import VisibilityIcon from "@material-ui/icons/Visibility";
import coachPhoto from "../../assets/image-not-available.png";
import moment from "moment";
import Flag from "react-flagkit";

const ListOfMyCoaches = ({
  coaches,
  previewImages,
  handleAppointment,
  handleSeeAvailabilty,
  handleSeeDetails,
}) => {
  const classes = useStyles();
  return (
    <GeneralListMyCoach>
      <Row style={{ width: "100%" }} className="mx-0 mx-md-4">
        {coaches.map((coach, index) => {
          return (
            <Col md={6} key={index} className={classes.cardCoach}>
              <Row>
                <Col md={3} className="pt-3">
                  <ImageCoach
                    previewImage={
                      previewImages.filter(
                        (item) => item.nameImage === coach.coverImage
                      )[0]?.urlImage
                    }
                    defaultCoachPhoto={coachPhoto}
                  />
                </Col>
                <Col md={9} className="pt-3 px-2 px-md-4 pb-0">
                  <CoachTitle>
                    {coach?.firstName + " " + coach?.lastName}
                  </CoachTitle>
                  <ContentDescriptLang>
                    Languages:
                    {coach?.wellnessCoachesLanguages &&
                      coach?.wellnessCoachesLanguages?.length > 0 &&
                      coach?.wellnessCoachesLanguages?.map((item, index) => {
                        return (
                          <Flag
                            key={index}
                            style={{ borderRadius: "99px" }}
                            className="mx-1"
                            country={`${
                              item?.idLanguage === "en"
                                ? "US"
                                : item?.idLanguage.toUpperCase()
                            }`}
                          />
                        );
                      })}
                  </ContentDescriptLang>

                  <DateDescription
                    onClick={() => {
                      if (coach?.turnsAvailable?.length > 0) {
                        handleAppointment(coach);
                      }
                    }}
                  >
                    <CalendarTodayIcon className={classes.iconCalendar} />{" "}
                    {coach?.turnsAvailable?.length > 0 && (
                      <span>
                        {moment(coach?.turnsAvailable[0].start).format("llll")}
                      </span>
                    )}
                  </DateDescription>

                  <AvailabilityAndViewButton>
                    <ButtonViewAvailability
                      className="btn-link"
                      onClick={() => handleSeeAvailabilty(coach)}
                    >
                      Availability
                    </ButtonViewAvailability>
                    <ButtonViewDetails
                      className="btn-link"
                      onClick={() => handleSeeDetails(coach)}
                    >
                      <VisibilityIcon />
                    </ButtonViewDetails>
                  </AvailabilityAndViewButton>
                </Col>
              </Row>
            </Col>
          );
        })}
      </Row>
    </GeneralListMyCoach>
  );
};
export default ListOfMyCoaches;
